import actions from '@/vuex/modules/ui/toolbar/actions'
import getters from '@/vuex/modules/ui/toolbar/getters'
import mutations from '@/vuex/modules/ui/toolbar/mutations'

const namespaced = true

const state = {
  // 設定ボタンの表示
  isSettingButtonVisible: false,
  // アカウント設定ボタンの表示
  isAccountSettingButtonVisible: false,
  // 案件選択ボタンの表示
  isIOSelectButtonVisible: false,
  // 広告主選択ボタンの表示
  isAdvSelectButtonVisible: false,
  //通知ベルボタンの表示
  isNotificationButtonVisible: false,
}

/*
 * メニュー情報を保持するmodule
 */
const drawerToggleButton = {
  state: state,
  namespaced: namespaced,
  getters: getters,
  actions: actions,
  mutations: mutations,
}

export default drawerToggleButton
